import { TableColumProps } from "@/components/molecules/Table";
import { fakeI18n } from "@/i18n";
import { RelatedActivitySortProperty } from "@/shared/domain";

export const activitiesTableDesktopColumns: TableColumProps<MyBrokerApi.Activity, RelatedActivitySortProperty>[] = [
    {
        sortableKey: "dueDate",
        label: fakeI18n.t("Common.Date"),
        width: 15,
    },
    {
        sortableKey: "description",
        label: fakeI18n.t("Activities.Activity"),
        width: 50,
    },
    {
        notSortable: true,
        unsortableKey: "isClosed",
        label: fakeI18n.t("Common.Status"),
        width: 10,
    },
];

export const activitiesTableMobileColumns: TableColumProps<MyBrokerApi.Activity, RelatedActivitySortProperty>[] = [
    {
        sortableKey: "dueDate",
        label: fakeI18n.t("Activities.Activity"),
        width: "100%",
    },
];
